module.exports = __webpack_public_path__ + "img/icon-1.c1d03797.png";